var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRouteMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-route-marker"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "route-marker",
    clipPath: "url(#clip-route-marker)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23546",
    "data-name": "Group 23546",
    transform: "translate(7861.705 -2920.355) rotate(-1)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1802",
    "data-name": "Ellipse 1802",
    cx: 6.418,
    cy: 7.131,
    rx: 6.418,
    ry: 7.131,
    transform: "translate(-7902.458 2789.575)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29423",
    "data-name": "Path 29423",
    d: "M12.455,18.09a5.3,5.3,0,0,0,5.3-5.3,5.458,5.458,0,0,0-5.3-5.493,5.3,5.3,0,0,0-5.3,5.3A5.591,5.591,0,0,0,12.455,18.09Zm-8.9-14.4A12.591,12.591,0,0,1,21.358,21.5l-8.9,8.9-8.9-8.9A12.934,12.934,0,0,1,3.552,3.694Z",
    transform: "matrix(0.999, 0.035, -0.035, 0.999, -7907.744, 2783.352)",
    fill: "#fe5969",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRouteMarker);
export default __webpack_public_path__ + "static/media/route-marker.61769df28b665550bb7321c50793b118.svg";
export { ForwardRef as ReactComponent };